import styled from 'styled-components';

import Media from '../../../assets/styles/media';
import THEME from '../../../assets/styles/config';
import brand from '../../../branding';

export const ContentCtn = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const FullWidthCtn = styled.div`
  flex: 0 0 100%;
`;

export const ReactiveListCtn = styled.div`
  flex: 0 0 43%;

  ${Media.Below.desktopLarge`
    flex: 1 0 100%;
  `}

  ${Media.Below.tablet`
    flex: 1 0 100%;
  `}
`;

export const PlannedListCtn = styled.div`
  flex: 0 0 43%;

  ${Media.Below.desktopLarge`
    flex: 1 0 100%;
    padding-top: 80px;
  `}

  ${Media.Below.tablet`
    flex: 1 0 100%;
  `}
`;

export const HeadingCtn = styled.div`
  display: flex;
  justify-content: space-between;

  > span {
    font-size: 30px;
    font-weight: bold;

    ${Media.Below.desktop`
      font-size: 24px;
    `}

    ${Media.Below.tablet`
      font-size: 22px;
    `}

    ${Media.Below.mobileLarge`
      font-size: 20px;
    `}
  }

  ${Media.Below.mobileLarge`
    flex-direction: column;
  `}

  /* The side-by-side lists hold their cards in from the column edge, so the heading is held in by the same
     amount and VIEW ALL ends where the cards end. Stacked below this width the cards are full width. */
  ${Media.Above.desktopLarge`
    padding-right: 25px;
  `}

  /* Just over the side-by-side breakpoint each column is only about 450px wide, so the 30px title shares its
     line with the button badly and wraps in two. Smaller until the columns have room. */
  @media screen and (min-width: 1441px) and (max-width: 1700px) {
    > span {
      font-size: 22px;
    }
  }

  /* Side by side, both lists' headings are the same height so the first cards line up. */
  ${Media.Above.desktopLarge`
    min-height: 70px;
  `}

  /* The 'data as at' note is context, not a heading, and sits under the title so it never wraps beside it. */
  > span > small {
    display: block;
    margin-top: 2px;
    font-size: 14px;
    font-weight: normal;
    color: ${THEME.colors.primaryFontColor};
    opacity: 0.65;
  }
`;

export const LinkToPage = styled.div`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  align-self: flex-start;
  margin-top: 4px;
  width: auto;
  white-space: nowrap;
  cursor: pointer;
  padding: 6px 16px;
  border: 1px solid ${THEME.colors.primaryFontColor};
  border-radius: 16px;
  color: ${THEME.colors.primaryFontColor};
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

  :hover {
    background-color: ${THEME.colors.primaryFontColor};
    color: white;
    text-decoration: none;
  }

  ${Media.Below.tablet`
    align-self: center;
    font-size: 12px;
  `}

  ${Media.Below.mobileLarge`
    align-self: end;
  `}
`;

export const PageCtn = styled.div`
  width: 90%;
  padding: 4vw 0 0 6vw;

  ${Media.Below.tablet`
    width: 100%;
    padding: 55px 30px 0;
  `}

  ${Media.Below.mobileLarge`
    padding: 50px 15px 0;
  `}
`;

export const PageHeaderImgCtn = styled.div`
  height: 100px;

  ${Media.Below.desktop`
    height: 65px;
  `}

  ${Media.Below.mobileLarge`
    display: flex;
    justify-content: center;
    height: 70px;
  `}

  > img {
    /* A brand logo (e.g. AIAL's wide wordmark) would blow out a height-only slot,
       so branded sites cap it to a sensible box; unbranded keeps the original. */
    ${brand.logo
      ? 'max-height: 100%; max-width: 280px; width: auto; height: auto;'
      : 'height: 100%;'}
  }
`;

export const PageHeaderText = styled.span`
  font-size: 18px;

  ${Media.Below.desktop`
    font-size: 15px;
  `}

  ${Media.Below.mobileLarge`
    font-size: 15px;
    text-align: center;
  `}
`;
